import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";

const getOrderPurchaseByRef = (idUser, reference) => {
  return api.get(`/purchaseOrder/getOrderPurchaseByRef/${reference}/${idUser}`);
};

const transfertPurchaseToRealWarehouseFromVirtuelWarehouse = (
  validateOrderPurchaseModel
) => {
  return api.post(
    "/purchaseOrder/transfertPurchaseToRealWarehouseFromVirtuelWarehouse/",
    validateOrderPurchaseModel
  );
};
//devis
const getDevisByRef = (quotationReference) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getDevisByRef/${currentUser}/${quotationReference}`
  );
};

const getAllDevisNotArchived = () => {
  let currentUser = currentUserId();
  return api.get(`/retail/document/getAllDevisNotArchived/${currentUser}`);
};

const getAllDevisNotRelatedToBDCeNotArchived = () => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getAllDevisNotRelatedToBDCeNotArchived/${currentUser}`
  );
};

const addDevis = (devisModel) => {
  let currentUser = currentUserId();
  devisModel.idUser = currentUser;

  return api.post("/retail/document/addDevis", devisModel);
};

const getDevisOfLastMonth = (isDeleted) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getDevisOfLastMonth/${currentUser}/${isDeleted}`
  );
};

const getDevisByFilters = (idSupplier, state, datedebut, dateFin) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getDevisByFilters/${currentUser}/${datedebut}/${dateFin}/${state}/${idSupplier}`
  );
};

const updateDevisPathFile = (refDevis, path) => {
  let currentUser = currentUserId();
  let updateADocumentPathFilePathModel = {
    idUser: currentUser,
    refDocument: refDevis,
    path: path,
  };
  return api.put(
    "/retail/document/updateDevisPathFile/",
    updateADocumentPathFilePathModel
  );
};

const deleteAndRestoreDevis = (refDevis, isDeleted) => {
  let currentUser = currentUserId();
  return api.put(
    `/retail/document/deleteAndRestoreDevis/${currentUser}/${refDevis}/${isDeleted}`
  );
};

//Bons de commande

const getBDCByRefForTransfert = (quotationReference) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getBDCByRefForTransfert/${currentUser}/${quotationReference}`
  );
};
const getBDCByRef = (quotationReference) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getBDCByRef/${currentUser}/${quotationReference}`
  );
};

const getAllBDCNotArchived = () => {
  let currentUser = currentUserId();
  return api.get(`/retail/document/getAllBDCNotArchived/${currentUser}`);
};

const getAllRefBDCNotArchived = () => {
  let currentUser = currentUserId();
  return api.get(`/retail/document/getAllRefBDCNotArchived/${currentUser}`);
};

const allRefNotLiveredBDCNotArchived = () => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getAllRefNotLiveredBDCNotArchived/${currentUser}`
  );
};

const getAllBDCNotRelatedToFactureAndNotArchived = () => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getAllBDCNotRelatedToFactureAndNotArchived/${currentUser}`
  );
};

const addBDC = (bdcModel) => {
  // let currentUser = currentUserId();
  // bdcModel.idUser = currentUser;

  return api.post("/retail/document/addBDC", bdcModel);
};

const getBDCOfLastMonth = (isDeleted) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getBDCOfLastMonth/${currentUser}/${isDeleted}`
  );
};

const getBDCByFilters = (idSupplier, state, datedebut, dateFin,magasinId) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getBDCByFilters/${currentUser}/${datedebut}/${dateFin}/${state}/${idSupplier}/${magasinId}`
  );
};

const updateBDCPathFile = (refDevis, path) => {
  let currentUser = currentUserId();
  let updateADocumentPathFilePathModel = {
    idUser: currentUser,
    refDocument: refDevis,
    path: path,
  };
  return api.put(
    "/retail/document/updateBDCPathFile/",
    updateADocumentPathFilePathModel
  );
};

const deleteAndRestoreBDC = (refDevis, isDeleted) => {
  let currentUser = currentUserId();
  return api.put(
    `/retail/document/deleteAndRestoreBDC/${currentUser}/${refDevis}/${isDeleted}`
  );
};

const verifieDevisExistanceByReference = (refDevis) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/verifieDevisExistanceByReference/${currentUser}/${refDevis}`
  );
};

//facture

const getFactureByRef = (factureReference) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getFactureByRef/${currentUser}/${factureReference}`
  );
};
const getAllFactureNotArchived = () => {
  let currentUser = currentUserId();
  return api.get(`/retail/document/getAllFactureNotArchived/${currentUser}`);
};

const addFacture = (factureModel) => {
  let currentUser = currentUserId();
  factureModel.idUser = currentUser;

  return api.post("/retail/document/addFacture", factureModel);
};

const getFactureOfLastMonth = (isDeleted) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getFactureOfLastMonth/${currentUser}/${isDeleted}`
  );
};

const getFactureByFilters = (idSupplier, state, datedebut, dateFin,shopId) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/getFactureByFilters/${currentUser}/${datedebut}/${dateFin}/${state}/${idSupplier}/${shopId}`
  );
};

const verifieFactureExistanceByReference = (refFacture) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/document/verifieFactureExistanceByReference/${currentUser}/${refFacture}`
  );
};

const updateFacturePathFile = (refFacture, path) => {
  let currentUser = currentUserId();
  let updateADocumentPathFilePathModel = {
    idUser: currentUser,
    refDocument: refFacture,
    path: path,
  };
  return api.put(
    "/retail/document/updateFacturePathFile/",
    updateADocumentPathFilePathModel
  );
};

const deleteAndRestoreFacture = (refFacture, isDeleted) => {
  let currentUser = currentUserId();
  return api.put(
    `/retail/document/deleteAndRestoreFacture/${currentUser}/${refFacture}/${isDeleted}`
  );
};

//purchase

const getPOByRef = (poReference) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/purchaseOrder/getOrderPurchaseByRef/${poReference}/${currentUser}`
  );
};

const addOrderPurchaseToVRWarehouse = (purchaseOrderModel) => {
  let currentUser = currentUserId();
  purchaseOrderModel.idUser = currentUser;

  return api.post(
    "/retail/purchaseOrder/addOrderPurchaseToWarehouse",
    purchaseOrderModel
  );
};

const getPOOfLastMonth = (isDeleted) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/purchaseOrder/getPOOfLastMonth/${currentUser}/${isDeleted}`
  );
};

const getPOByFilters = (idSupplier, state, datedebut, dateFin) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/purchaseOrder/getPOByFilters/${currentUser}/${datedebut}/${dateFin}/${state}/${idSupplier}`
  );
};

const deleteAndRestorePO = (refPO, isDeleted) => {
  let currentUser = currentUserId();
  return api.put(
    `/retail/purchaseOrder/deleteAndRestorePO/${currentUser}/${refPO}/${isDeleted}`
  );
};

const updateFacturePathFileInPO = (refPO, path) => {
  let currentUser = currentUserId();
  let updateADocumentPathFilePathModel = {
    idUser: currentUser,
    refDocument: refPO,
    path: path,
  };
  return api.put(
    "/retail/purchaseOrder/updateFacturePathFileInPO",
    updateADocumentPathFilePathModel
  );
};

const getPurchaseByRefPOOrByRefFacture = (reference) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/purchaseOrder/getPurchaseByRefPOOrByRefFacture/${reference}/${currentUser}`
  );
};
// const getPurchaseByBonCommande = (reference) => {
//   let currentUser = currentUserId();
//   return api.get(
//     `/retail/purchaseOrder/getPurchaseByBonCommande/${reference}/${currentUser}`
//   );
// };
const getAllPOO = () => {
  let currentUser = currentUserId();
  return api.get(`/retail/purchaseOrder/getAllPOO/${currentUser}`);
};

const getProductPurchaseCurrentQte = (idProductPurchase) => {
  let currentUser = currentUserId();
  return api.get(
    `/retail/purchaseOrder/getProductPurchaseCurrentQte/${idProductPurchase}/${currentUser}`
  );
};

// language ("fr" / "en"): the file is generated in that language, which becomes the one of the order
const generateBD = (refBD, language) => {
  let idUser = currentUserId();
  return api.get(
    `/retail/uploadFile/generateBD/${idUser}/${refBD}`,
    language ? { params: { language } } : undefined
  );
};

const generateFactureFromPurchaseOrder = (purchaseOrderList) => {
  let idUser = currentUserId();

  return api.put(
    `/retail/purchaseOrder/generateFactureFromPurchaseOrder/${idUser}`,
    purchaseOrderList
  );
};

const validatePurchaseOrderToRealWarehouse = (
  validatePurchaseOrderToRealWarehouseModel
) => {
  let currentUser = currentUserId();
  validatePurchaseOrderToRealWarehouseModel.idUser = currentUser;

  return api.post(
    "/retail/purchaseOrder/validatePurchaseOrderToRealWarehouse",
    validatePurchaseOrderToRealWarehouseModel
  );
};

// const validatePurchaseOrderBDCToRealWarehouse = (
//   validatePurchaseOrderToRealWarehouseModel
// ) => {
//   let currentUser = currentUserId();
//   validatePurchaseOrderToRealWarehouseModel.idUser = currentUser;

//   return api.post(
//     "/retail/purchaseOrder/validatePurchaseOrderBDCToRealWarehouse",
//     validatePurchaseOrderToRealWarehouseModel
//   );
// };

const getPurchaseHistoryByWarehouse = (
  refPurchaseOrderOrRefFacture,
  idWarehouse
) => {
  let idUser = currentUserId();
  return api.get(
    `/retail/purchaseOrder/getPurchasesHistoryByWarehouse/${refPurchaseOrderOrRefFacture}/${idUser}/${idWarehouse} `
  );
};

const attachedStoreToFacture = (
  idUser,
  idFacture,
  idShop
) => {
  return api.get(
    `/retail/document/attachedStoreToFacture/${idUser}/${idFacture}/${idShop} `
  );
};

export default {
  attachedStoreToFacture,
  getOrderPurchaseByRef,
  transfertPurchaseToRealWarehouseFromVirtuelWarehouse,
  getDevisByRef,
  addDevis,
  getDevisOfLastMonth,
  getDevisByFilters,
  updateDevisPathFile,
  deleteAndRestoreDevis,
  verifieDevisExistanceByReference,
  getAllDevisNotArchived,
  getAllDevisNotRelatedToBDCeNotArchived,
  getBDCByRef,
  getBDCByRefForTransfert,
  addBDC,
  getBDCOfLastMonth,
  getBDCByFilters,
  updateBDCPathFile,
  deleteAndRestoreBDC,
  generateBD,
  getAllBDCNotArchived,
  getAllBDCNotRelatedToFactureAndNotArchived,
  getAllRefBDCNotArchived,
  allRefNotLiveredBDCNotArchived,
  getFactureByRef,
  addFacture,
  getFactureOfLastMonth,
  getFactureByFilters,
  updateFacturePathFile,
  deleteAndRestoreFacture,
  verifieFactureExistanceByReference,
  getAllFactureNotArchived,

  getPOByRef,
  addOrderPurchaseToVRWarehouse,
  getPOOfLastMonth,
  getPOByFilters,
  deleteAndRestorePO,
  updateFacturePathFileInPO,
  getPurchaseByRefPOOrByRefFacture,
  // getPurchaseByBonCommande,
  getProductPurchaseCurrentQte,
  getAllPOO,
  generateFactureFromPurchaseOrder,

  validatePurchaseOrderToRealWarehouse,
  // validatePurchaseOrderBDCToRealWarehouse,

  getPurchaseHistoryByWarehouse,
};
